var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('ul',{staticClass:"menu"},_vm._l((_vm.navList),function(item){return _c('li',{key:item.icon,class:{
        active: _vm.currentPage == item.pathName
      },on:{"click":function($event){return _vm.linkTo(item.path)}}},[_c('i',{class:item.icon}),_c('span',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }